import React from 'react';
import { Alert, Modal, Progress, Space, Tag, Tooltip, Typography, message } from 'antd';
import { useTranslation, t as tt } from '../../../../shared/i18n';
import { Copyable } from '../../../components/DnsOneClick';

const { Text } = Typography;

export { Copyable };

export const ok = (res) => res && (res.code === 0 || res.success === true);
export const errMsg = (e, fallback) => e?.error || e?.message || fallback;
/** apiClient 已对 4xx(除 404)/403/5xx/网络错误弹过提示；这里只补它不弹的（404、或 quiet 请求） */
export const toastErr = (e, fallback, quiet = false) => {
    if (quiet || e?.status === 404) message.error(errMsg(e, fallback));
};

export const fmtNum = (n) => (n === null || n === undefined ? '-' : Number(n).toLocaleString());
export const fmtTime = (s) => (s ? String(s).replace('T', ' ').slice(0, 19) : '-');

const STREAM_STATUS = {
    active: { color: 'green', text: '正常' },
    paused: { color: 'orange', text: '已暂停' },
    suspended: { color: 'default', text: '已停用' },
    banned: { color: 'red', text: '已封禁' },
    terminated: { color: 'default', text: '已释放' },
};

export const StreamStatusTag = ({ stream }) => {
    const { t } = useTranslation();
    const st = STREAM_STATUS[stream.status] || { color: 'default', text: stream.status };
    const reason = stream.status === 'banned' ? stream.banned_reason : stream.status === 'paused' ? stream.paused_reason : null;
    const tag = <Tag color={st.color} style={{ marginInlineEnd: 0 }}>{t(st.text)}</Tag>;
    return reason ? <Tooltip title={reason}>{tag}</Tooltip> : tag;
};

export const StreamTypeTag = ({ type }) => {
    const { t } = useTranslation();
    return type === 'marketing'
        ? <Tag color="purple" style={{ marginInlineEnd: 0 }}>{t('Marketing')}</Tag>
        : <Tag color="blue" style={{ marginInlineEnd: 0 }}>{t('Transactional')}</Tag>;
};

export const SandboxTag = () => {
    const { t } = useTranslation();
    return (
        <Tooltip title={t('Sandbox: 100 emails a day, to verified recipients only')}>
            <Tag color="gold" style={{ marginInlineEnd: 0 }}>{t('Sandbox')}</Tag>
        </Tooltip>
    );
};

/** 本月用量条：monthly_limit = -1 不限 */
export const UsageBar = ({ usage }) => {
    const { t } = useTranslation();
    const used = usage?.monthly_used || 0;
    const limit = usage?.monthly_limit;
    const unlimited = limit === -1 || limit === null || limit === undefined;
    const pct = unlimited || !limit ? 0 : Math.min(100, Math.round((used / limit) * 100));
    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                <Text type="secondary">{t('this month')}</Text>
                <Text>{fmtNum(used)} / {unlimited ? t('Unlimited') : fmtNum(limit)}</Text>
            </div>
            <Progress percent={pct} showInfo={false} size="small" status={pct >= 100 ? 'exception' : 'normal'} />
            <Text type="secondary" style={{ fontSize: 12 }}>
                {t('{{n}} left this hour', { n: usage?.hourly_remaining === -1 ? t('Unlimited') : fmtNum(usage?.hourly_remaining) })}
            </Text>
        </div>
    );
};

const MSG_STATUS = {
    queued: { color: 'processing', text: '排队中' },
    delivered: { color: 'green', text: '已送达' },
    deferred: { color: 'gold', text: '延迟重试' },
    bounced: { color: 'red', text: '退信' },
    complained: { color: 'magenta', text: '投诉' },
    rejected: { color: 'default', text: '已拒绝' },
    failed: { color: 'red', text: '失败' },
};
export const MESSAGE_STATUSES = Object.keys(MSG_STATUS);
export const messageStatusText = (s) => tt(MSG_STATUS[s]?.text || s);
export const MessageStatusTag = ({ status }) => {
    const { t } = useTranslation();
    const st = MSG_STATUS[status] || { color: 'default', text: status };
    return <Tag color={st.color} style={{ marginInlineEnd: 0 }}>{t(st.text)}</Tag>;
};

/** 一次性显示的密钥（API key / webhook secret） */
export const showSecretOnce = ({ title, secret, note }) => {
    Modal.success({
        title,
        width: 560,
        okText: tt('I\'ve saved it'),
        content: (
            <Space direction="vertical" style={{ width: '100%' }}>
                <Alert type="warning" showIcon message={tt('Shown only once; you can\'t view it again after closing')} />
                <Copyable value={secret} strong />
                {note ? <Text type="secondary">{note}</Text> : null}
            </Space>
        ),
    });
};
